/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many sets can I use?`)
};

const es_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos conjuntos puedo usar?`)
};

const de_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Mengen kann ich verwenden?`)
};

const nl_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel sets kan ik gebruiken?`)
};

const fr_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien d'ensembles puis-je utiliser ?`)
};

const it_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti insiemi posso usare?`)
};

const pt_br2_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos conjuntos posso usar?`)
};

const pt_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos conjuntos posso usar?`)
};

const ja_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いくつの集合を使えますか?`)
};

const zh_venn_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以使用多少个集合？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_q2", locale)
	if (locale === "en") return en_venn_faq_q2(inputs)
	if (locale === "es") return es_venn_faq_q2(inputs)
	if (locale === "de") return de_venn_faq_q2(inputs)
	if (locale === "nl") return nl_venn_faq_q2(inputs)
	if (locale === "fr") return fr_venn_faq_q2(inputs)
	if (locale === "it") return it_venn_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_q2(inputs)
	if (locale === "pt") return pt_venn_faq_q2(inputs)
	if (locale === "ja") return ja_venn_faq_q2(inputs)
	return zh_venn_faq_q2(inputs)
};